// Mock data for Waypoint Transformation website

export const LOGOS = {
  horizontal: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/j2v3vmlu_Waypoint%20Logo%20-%20Image%20Left%20and%20Text%20Right%20-%20Small%20Borders.png',
  stacked: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/vx20wst7_Waypoint%20Logo%20Top%2C%20words%20below.webp',
};

export const IMAGES = {
  fractionalCio: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/x0ym5zo6_Fraction%20CIO%20Services.png',
  fractionalCto: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/tanxamcf_CTO%20Roadmap_Strategy.png',
  engineeringLeadership: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/j7c2txqp_Technical%20Leadership.png',
  globalTransformation: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/2n5tzc55_Global%20Transformation.png',
  interimLeadership: 'https://customer-assets.emergentagent.com/job_waypoint-tech/artifacts/36vs4mfu_Interim%20Leadership.png',
  heroBoardroom: 'https://images.unsplash.com/photo-1704423846283-f92ff6badea3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fGJsdWV8MTc4Mzg5MjE3N3ww&ixlib=rb-4.1.0&q=85',
  officeCity: 'https://images.unsplash.com/photo-1547321568-f2e8dbaa32d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fGJsdWV8MTc4Mzg5MjE3N3ww&ixlib=rb-4.1.0&q=85',
  techAbstract: 'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwYWJzdHJhY3R8ZW58MHx8fGJsdWV8MTc4Mzg5MjE3N3ww&ixlib=rb-4.1.0&q=85',
  techBlue: 'https://images.unsplash.com/photo-1604011237320-8e0506614fdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHx0ZWNobm9sb2d5JTIwYWJzdHJhY3R8ZW58MHx8fGJsdWV8MTc4Mzg5MjE3N3ww&ixlib=rb-4.1.0&q=85',
  meeting: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzgzODkyMTc3fDA&ixlib=rb-4.1.0&q=85',
  dashboard: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxkYXRhJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc4Mzg5MjE3OHww&ixlib=rb-4.1.0&q=85',
  ai1: 'https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxBSSUyMGFydGlmaWNpYWwlMjBpbnRlbGxpZ2VuY2V8ZW58MHx8fHwxNzgzODkyMTgzfDA&ixlib=rb-4.1.0&q=85',
  ai2: 'https://images.unsplash.com/photo-1694903089438-bf28d4697d9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxBSSUyMGFydGlmaWNpYWwlMjBpbnRlbGxpZ2VuY2V8ZW58MHx8fHwxNzgzODkyMTgzfDA&ixlib=rb-4.1.0&q=85',
  globe1: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxnbG9iYWwlMjBuZXR3b3JrfGVufDB8fHx8MTc4Mzg5MjE4M3ww&ixlib=rb-4.1.0&q=85',
  globe2: 'https://images.unsplash.com/photo-1597733336794-12d05021d510?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxnbG9iYWwlMjBuZXR3b3JrfGVufDB8fHx8MTc4Mzg5MjE4M3ww&ixlib=rb-4.1.0&q=85',
};

export const SERVICES = [
  {
    id: 'fractional-cio',
    title: 'Fractional CIO Services',
    kicker: 'Executive IT Leadership',
    tagline: 'Technology leadership that keeps pace with the business, not just the infrastructure.',
    description: 'Our fractional CIOs align IT decisions with operational needs and long-term objectives, giving mid-market and growth-stage organizations senior-level oversight without the full-time overhead.',
    bullets: [
      'Technology strategy and multi-year roadmaps',
      'Oversight of IT budgets, investments, and vendor portfolios',
      'Governance, standards, and performance accountability',
      'Leadership for modernization, cloud, and enterprise initiatives',
      'IT process design and digital transformation',
    ],
    image: IMAGES.fractionalCio,
  },
  {
    id: 'engineering-leadership',
    title: 'Engineering & Technical Leadership',
    kicker: 'Building That Ships',
    tagline: 'Senior engineering leadership and hands-on engineers who move the work forward.',
    description: 'Great architecture only matters if teams can execute against it. Our fractional engineering leaders — and the senior engineers who work alongside them — stand up delivery discipline, unblock the hard problems, and mentor internal teams so the improvements stick after we\u2019re gone.',
    bullets: [
      'Fractional VP Engineering and Head of Engineering roles',
      'Senior engineers embedded on critical initiatives',
      'Delivery cadence, code review, and technical hiring frameworks',
      'Platform, DevOps, and cloud engineering leadership',
      'Mentorship and coaching for internal engineering leaders',
    ],
    image: IMAGES.engineeringLeadership,
  },
  {
    id: 'fractional-cto',
    title: 'Fractional CTO Services',
    kicker: 'Architectural Discipline',
    tagline: 'Architectural decisions shape what an organization can do tomorrow.',
    description: 'Our fractional CTOs bring structure and discipline to complex technical environments — aligning engineering, IT, and business leadership around sound architecture that prevents today’s choices from becoming tomorrow’s constraints.',
    bullets: [
      'Enterprise and solution architecture guidance',
      'Platform, application, and integration strategy',
      'Technical due diligence for major initiatives or acquisitions',
      'Alignment between engineering, IT, and business leadership',
      'AI adoption governance and cost controls',
    ],
    image: IMAGES.fractionalCto,
  },
  {
    id: 'program-management',
    title: 'Program Management',
    kicker: 'Disciplined Delivery',
    tagline: 'Ensuring your partners deliver on contract, on schedule, and on strategy.',
    description: 'From program setup to vendor negotiations, we provide the operating rigor that keeps complex, cross-functional initiatives moving — with clear accountability, budgets that stay on track, and outcomes that are measurable.',
    bullets: [
      'Program setup, governance, and reporting cadences',
      'Budget tracking and financial accountability',
      'Vendor negotiations and partner performance oversight',
      'Roadmapping, strategy, and disciplined execution',
      'Risk management and issue escalation frameworks',
    ],
    image: IMAGES.dashboard,
  },
  {
    id: 'global-transformation',
    title: 'Global Transformation',
    kicker: 'Large-Scale Change, Delivered',
    tagline: 'Large-scale, global transformation leadership across every continent.',
    description: 'We lead complex enterprise transformations — ERP, Financials, HR, Payroll, Workforce Management, and single sign-on programs — with a proven approach that pairs strategic clarity with operational rigor.',
    bullets: [
      'ERP, Financials, HR, and Payroll transformations',
      'Workforce Management and single sign-on programs',
      'Global program setup and multi-region rollout',
      'Vendor selection, negotiation, and contract governance',
      'Change management and value realization',
    ],
    image: IMAGES.globalTransformation,
  },
  {
    id: 'interim-leadership',
    title: 'Interim Leadership',
    kicker: 'Continuity Through Change',
    tagline: 'Continuity and direction during executive transitions.',
    description: 'Leadership transitions introduce uncertainty at exactly the wrong time. Our interim executives keep programs, audits, and regulatory obligations on track while you search for the right long-term hire.',
    bullets: [
      'Short-term executive leadership during turnover or restructuring',
      'Assessment of staff capabilities and leadership gaps',
      'Continuity for programs, audits, and regulatory obligations',
      'Structured handoff to permanent leadership',
    ],
    image: IMAGES.interimLeadership,
  },
  {
    id: 'ai-transformation',
    title: 'AI Transformation',
    kicker: 'Becoming AI-Native',
    tagline: 'From your current environment to an AI-native enterprise of tomorrow.',
    description: 'Our approach to AI transformation is designed to deliver tangible outcomes. We re-engineer and design future-state architectures that create intelligent environments built for agility and efficiency.',
    bullets: [
      'AI-ready enterprise architecture design',
      'AI adoption governance, security review, and cost controls',
      'Workforce upskilling and change orchestration',
      'Platform-enabled, value-driven, and change-ready',
    ],
    image: IMAGES.ai1,
  },
];

export const PRINCIPLES = [
  { name: 'Platform-enabled', desc: 'A flexible foundation that is interoperable and scalable by design — providing visibility, control, and agility.' },
  { name: 'AI-first', desc: 'Leveraging AI to accelerate transformation and deliver real, measurable results.' },
  { name: 'Experience-led', desc: 'Prioritizing the human experiences that define technology and change strategies.' },
  { name: 'Value-driven', desc: 'Delivering against quantified, measurable KPIs that align with business goals.' },
  { name: 'Change-ready', desc: 'Solutions that improve agility and enable continual evolution.' },
];

export const SIGNALS = [
  { title: 'Decisions lack technical context', desc: 'Product, roadmap, and investment decisions move forward without a senior technical perspective, leading to tradeoffs that surface too late.' },
  { title: 'Systems evolve without direction', desc: 'Architecture grows organically rather than intentionally, increasing complexity and making future changes harder and riskier.' },
  { title: 'Engineering execution drifts', desc: 'Without clear leadership, teams pull in different directions — slowing delivery, increasing rework, and eroding accountability.' },
  { title: 'Scaling exposes leadership gaps', desc: 'As teams, customers, or investors raise expectations, the absence of experienced technical leadership becomes impossible to ignore.' },
];

export const INSIGHTS = [
  {
    id: 'fractional-cio-cto-business-impact',
    category: 'Fractional Leadership',
    title: 'How Fractional CIOs and CTOs Reshape a Mid-Market Business',
    excerpt: 'Executive-grade technology leadership — without the full-time overhead. A practical look at how fractional CIOs and CTOs turn IT from a cost center into a growth engine.',
    author: 'Waypoint Editorial',
    date: 'November 12, 2025',
    readTime: '8 min read',
    image: IMAGES.techBlue,
  },
  {
    id: 'when-cio-level-leadership',
    category: 'IT Strategy',
    title: 'When IT Needs CIO-Level Leadership',
    excerpt: 'The signals that indicate a business has outgrown ad hoc IT ownership — and what senior direction, accountability, and risk control actually change.',
    author: 'Sean Murray',
    date: 'October 28, 2025',
    readTime: '6 min read',
    image: IMAGES.dashboard,
  },
  {
    id: 'controlling-enterprise-implementation-cost',
    category: 'Enterprise Technology',
    title: 'Controlling the Real Cost of Enterprise Software',
    excerpt: 'ERP, CRM, HCM, ITSM — the license fee is rarely the story. A field guide to the hidden costs of enterprise implementations and how disciplined leadership contains them.',
    author: 'Waypoint Editorial',
    date: 'October 10, 2025',
    readTime: '7 min read',
    image: IMAGES.ai2,
  },
];

export const STATS = [
  { value: '$731B', label: 'Projected global managed services market by 2030' },
  { value: '85%', label: 'Of mid-market organizations rely on MSPs for security' },
  { value: '6–18mo', label: 'Typical enterprise ERP implementation window' },
  { value: '6', label: 'Continents served by our transformation leaders' },
];
